var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiUxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 915,
    height: 504,
    viewBox: "0 0 915 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 84,
    width: 420,
    height: 420,
    rx: 75,
    fill: "url(#paint0_linear_1_9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    width: 420,
    height: 420,
    rx: 75,
    fill: "url(#paint1_linear_1_9)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 420,
    height: 420,
    rx: 75,
    fill: "url(#paint2_linear_1_9)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 420,
    height: 420,
    rx: 75,
    fill: "url(#paint3_linear_1_9)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 495,
    y: 45,
    width: 420,
    height: 420,
    rx: 75,
    fill: "url(#paint4_linear_1_9)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.647 184V265.8C157.647 273.4 159.38 279.267 162.847 283.4C166.447 287.533 171.847 289.6 179.047 289.6C186.247 289.6 191.647 287.533 195.247 283.4C198.98 279.133 200.847 273.267 200.847 265.8V184H240.047V265.8C240.047 278.733 237.314 289.8 231.847 299C226.38 308.067 218.914 314.933 209.447 319.6C200.114 324.133 189.714 326.4 178.247 326.4C166.78 326.4 156.514 324.133 147.447 319.6C138.514 314.933 131.447 308.067 126.247 299C121.18 289.933 118.647 278.867 118.647 265.8V184H157.647ZM300.83 184V325H261.63V184H300.83Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M608.983 184V265.8C608.983 273.4 610.716 279.267 614.183 283.4C617.783 287.533 623.183 289.6 630.383 289.6C637.583 289.6 642.983 287.533 646.583 283.4C650.316 279.133 652.183 273.267 652.183 265.8V184H691.383V265.8C691.383 278.733 688.649 289.8 683.183 299C677.716 308.067 670.249 314.933 660.783 319.6C651.449 324.133 641.049 326.4 629.583 326.4C618.116 326.4 607.849 324.133 598.783 319.6C589.849 314.933 582.783 308.067 577.583 299C572.516 289.933 569.983 278.867 569.983 265.8V184H608.983ZM801.166 325L773.766 285.2L750.366 325H705.766L751.566 252.8L704.166 184H750.366L776.966 222.8L799.766 184H844.366L799.166 255L847.366 325H801.166Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9",
    x1: 432,
    y1: 84,
    x2: 852,
    y2: 504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA415",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2965",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_9",
    x1: 58,
    y1: 0,
    x2: 478,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0FF",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0654FF",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_9",
    x1: 0,
    y1: 45,
    x2: 420,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0654FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_9",
    x1: 0,
    y1: 45,
    x2: 420,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0654FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_9",
    x1: 495,
    y1: 45,
    x2: 915,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2965"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUxLogo);
export default __webpack_public_path__ + "static/media/ui-ux-logo.ecb47d9d6b86ab9474af53ca720a1dfb.svg";
export { ForwardRef as ReactComponent };